import { apiCall } from './gqlClient';

const CIRCUITEXERCISEPROGRESSIONS_QUERY = `
  query circuitExerciseProgressions($circuitExerciseId: String!) {
    circuitExerciseProgressions(circuitExerciseId: $circuitExerciseId)
    {
      id
			circuitExerciseId
			weekStart
			weekEnd
			setSeries
			executionMinValue
			executionMaxValue
			intensityType
			intensityValue
			weight
			deltaWeight
			durationSeconds
			triggerRepsAboveTarget
			triggerSessionsCompleted
			incrementValue
			maxValue
			notes
			dateCreated
			dateUpdated
      ...fragments
    }
  }`;

export const circuitExerciseProgressionsApiCall = async ({circuitExerciseId}, fragments = null) => apiCall({ query: CIRCUITEXERCISEPROGRESSIONS_QUERY, variables: {circuitExerciseId}, fragments });

const CREATECIRCUITEXERCISEPROGRESSION_QUERY = `
  mutation createCircuitExerciseProgression($input: CircuitExerciseProgressionInput!) {
    createCircuitExerciseProgression(input: $input)
    {
      id
			circuitExerciseId
			weekStart
			weekEnd
			setSeries
			executionMinValue
			executionMaxValue
			intensityType
			intensityValue
			weight
			deltaWeight
			durationSeconds
			triggerRepsAboveTarget
			triggerSessionsCompleted
			incrementValue
			maxValue
			notes
			dateCreated
			dateUpdated
      ...fragments
    }
  }`;

export const createCircuitExerciseProgressionApiCall = async ({input}, fragments = null) => apiCall({ query: CREATECIRCUITEXERCISEPROGRESSION_QUERY, variables: {input}, fragments });

const UPDATECIRCUITEXERCISEPROGRESSION_QUERY = `
  mutation updateCircuitExerciseProgression($id: String!, $input: CircuitExerciseProgressionInput!) {
    updateCircuitExerciseProgression(id: $id, input: $input)
    {
      id
			circuitExerciseId
			weekStart
			weekEnd
			setSeries
			executionMinValue
			executionMaxValue
			intensityType
			intensityValue
			weight
			deltaWeight
			durationSeconds
			triggerRepsAboveTarget
			triggerSessionsCompleted
			incrementValue
			maxValue
			notes
			dateCreated
			dateUpdated
      ...fragments
    }
  }`;

export const updateCircuitExerciseProgressionApiCall = async ({id, input}, fragments = null) => apiCall({ query: UPDATECIRCUITEXERCISEPROGRESSION_QUERY, variables: {id, input}, fragments });

const DELETECIRCUITEXERCISEPROGRESSION_QUERY = `
  mutation deleteCircuitExerciseProgression($id: String!) {
    deleteCircuitExerciseProgression(id: $id)
    {
      id
			circuitExerciseId
			weekStart
			weekEnd
			setSeries
			executionMinValue
			executionMaxValue
			intensityType
			intensityValue
			weight
			deltaWeight
			durationSeconds
			triggerRepsAboveTarget
			triggerSessionsCompleted
			incrementValue
			maxValue
			notes
			dateCreated
			dateUpdated
      ...fragments
    }
  }`;

export const deleteCircuitExerciseProgressionApiCall = async ({id}, fragments = null) => apiCall({ query: DELETECIRCUITEXERCISEPROGRESSION_QUERY, variables: {id}, fragments });
